export default __webpack_public_path__ + "static/media/most-awarded.bd53d5e5.png";